import type { ICommand } from '../interfaces/Command';

export class AnonymousCommand implements ICommand {
  private _execute: () => Promise<undefined | boolean>;

  public _undo?: () => Promise<undefined | boolean>;

  public constructor(execute: () => Promise<undefined | boolean>, undo?: () => Promise<undefined | boolean>) {
    this._execute = execute;
    if (undo) {
      this._undo = undo;
    }
  }

  public async execute(): Promise<undefined | boolean> {
    return this._execute();
  }

  public async undo(): Promise<undefined | boolean> {
    return this._undo?.();
  }
}
